import React from 'react';

var StepperContext = /*#__PURE__*/React.createContext({
  back: function back() {
    return null;
  },
  completeEdit: function completeEdit() {
    return null;
  },
  currentStep: '',
  edit: function edit(step) {
    return null;
  },
  goToStep: function goToStep(step) {
    return null;
  },
  isEditing: function isEditing() {
    return false;
  },
  next: function next() {
    return null;
  }
});

export { StepperContext };
